import React from 'react';
import PropTypes from 'prop-types';

import AnswerPanel from 'components/customer/answer_panel';
import connect from 'components/lib/connect';
import useIsTeamFlagEnabled from 'components/hooks/use_is_team_flag_enabled';
import SidePanel, { SidePanelType } from 'models/side_panel';
import TaskCommentPanel from 'components/customer/task_comments/task_comment_panel';
import TeamAssistPanel from 'components/customer/team_assist/team_assist_panel';

function CustomerSidePanel({ isAnswersReadEnabled, sidePanel }) {
  const isTeamFlagEnabled = useIsTeamFlagEnabled();
  const isTeamAssistEnabled = isTeamFlagEnabled('teamAssistAI');

  if (!sidePanel || !sidePanel.isOpen()) {
    return null;
  }

  if (sidePanel.isShowing(SidePanelType.ANSWER) && isAnswersReadEnabled) {
    return <AnswerPanel />;
  }

  if (sidePanel.isShowing(SidePanelType.TASK)) {
    return <TaskCommentPanel />;
  }

  if (isTeamAssistEnabled && sidePanel.isShowing(SidePanelType.AI_ASSIST)) {
    return <TeamAssistPanel />;
  }

  return null;
}

CustomerSidePanel.propTypes = {
  isAnswersReadEnabled: PropTypes.bool,
  sidePanel: PropTypes.instanceOf(SidePanel),
};

function mapStateToProps({ getProvider, isFeatureEnabled }) {
  const sidePanel = getProvider('sidePanel').get();
  const isAnswersReadEnabled = isFeatureEnabled('answers:read');

  return {
    isAnswersReadEnabled,
    sidePanel,
  };
}

export default connect(mapStateToProps)(CustomerSidePanel);
